import { apiClient } from '@mote/api'
import { canAccessWebLocalStorage } from '@mote/helpers/browser'
import {
  DEFAULT_LOCALE,
  WEB_STORAGE_PREFIX_KEYS
} from '@mote/helpers/constants'
import { getAuthAttribute } from '@mote/helpers/identity'
import { getTZOffset } from 'web/src/shared/Utils'

const CURRENT_VERSION = '2'
const STORAGE_VERSION_KEY = 'mote-storage-version'
const GOALS_KEY = `${WEB_STORAGE_PREFIX_KEYS}goals`

function getStorageVersion() {
  return window.localStorage.getItem(STORAGE_VERSION_KEY)
}

async function updateStorageVersion() {
  window.localStorage.setItem(STORAGE_VERSION_KEY, CURRENT_VERSION)
}

async function migrateLegacyUsers() {
  const userExists = getAuthAttribute('accessToken')
  const existingGoals = getAuthAttribute('goals')

  if (!userExists || existingGoals) return

  const fallbackGoals = {
    userOnboarding: 'skip_for_now',
    productOnboarding: 'required',
    makeFirstMote: 'required'
  }
  window.localStorage.setItem(GOALS_KEY, JSON.stringify(fallbackGoals))

  apiClient
    .extend({
      timeout: 4000,
      retry: {
        limit: 3,
        methods: ['post']
      }
    })
    .post('v1/c/account', {
      json: { TZOffset: getTZOffset() }
    })
    .json()
    .then(() => {
      window.location.reload(true)
    })
    .catch(() => {
      window.location.href = '/login?force=1'
    })
}

export const checkAndUpdateStorageVersion = async () => {
  if (!canAccessWebLocalStorage()) return

  const storageVersion = getStorageVersion()

  if (storageVersion && storageVersion === CURRENT_VERSION) return
  console.log('Storage version changed - updating')

  await updateStorageVersion()
  await migrateLegacyUsers()
}
